<template>
	<div>
		<br />
		<div class="table-responsive">
			<hr />
			<h5 v-if="!!busingDetails.TRANSPORTATION_STATUS_DESC">
				<strong>
					{{ $t('MAIN_CONTENT.BusingDetails.bussingStatusWithColon') }}<br />
				</strong>
				{{ busingDetails.TRANSPORTATION_STATUS_DESC }}
			</h5>
			<br />
			<h5 v-if="!!busingDetails.BUS_NOTES">
				<strong>
					{{ $t('MAIN_CONTENT.BusingDetails.bussingNotesWithColon') }}<br />
				</strong>
				<p v-html="busingDetails.BUS_NOTES"/>
			</h5>

			<!-- Start of bussing data -->
			<template v-if="busPeriods.length > 0">
				<table class="table table-bordered" v-for="(period, idx) in busPeriods" :key="`${period}_${idx}`">
					<thead>
						<tr class="active">
							<th>{{ $t('MAIN_CONTENT.BusingDetails.busWithColon', { period: period } ) }}</th>
							<th>{{ $t('MAIN_CONTENT.BusingDetails.stopWithColon') }}</th>
							<th>{{ $t('MAIN_CONTENT.BusingDetails.timeWithColon') }}</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="index in 3">
							<tr v-if="!!busingDetails[`${period}_BUS_NUMBER_${index}`] || !!busingDetails[`${period}_STOP_LOCATION_${index}`] || !!busingDetails[`${period}_STOP_TIME_${index}`]" :key="index">
								<td>
									{{ busingDetails[`${period}_BUS_NUMBER_${index}`] }}
								</td>
								<td>
									{{ busingDetails[`${period}_STOP_LOCATION_${index}`] }}
								</td>
								<td>
									{{ busingDetails[`${period}_STOP_TIME_${index}`] | time }}
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</template>
		</div>
		<!-- End of bussing data -->

		<br />
		<div v-if="!!busingDetails.PARKING_PERMIT || !!busingDetails.PARKING_PERMIT_LOCATION">
			<hr />
			<!-- Start of Parking data -->
			<h5>
				<strong>{{ $t('MAIN_CONTENT.BusingDetails.parkingInformationWithColon') }}</strong>
			</h5>
			<div class="row">
				<div class="col-sm-4" v-if="!!busingDetails.PARKING_PERMIT">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.permitWithColon') }}
					</strong>
					<br>
					{{ busingDetails.PARKING_PERMIT }}
				</div>
				<div class="col-sm-4" v-if="!!busingDetails.PARKING_PERMIT_LOCATION">
					<strong>
						{{ $t('MAIN_CONTENT.StudentInformation.locationWithColon') }}
					</strong>
					<br />
					{{ busingDetails.PARKING_PERMIT_LOCATION }}
				</div>
			</div>
			<!-- End of Parking data -->
		</div>

		<br />

		<!-- Start of Car Information -->
		<template v-if="hasCarInformation()">
			<hr />
			<h5>
				<strong>{{ $t('MAIN_CONTENT.BusingDetails.carInformationWithColon') }}</strong>
			</h5>
			<div class="row" v-if="firstRowCarInformation()">
				<div class="col-sm-4" v-if="!!busingDetails.PARKING_PERMIT_LICENSE_PLATE_ID">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.licensePlateWithColon') }}
					</strong>
					<br />
					{{ busingDetails.PARKING_PERMIT_LICENSE_PLATE_ID }}
				</div>
				<div class="col-sm-4" v-if="!!busingDetails.PARKING_PERMIT_MAKE_MODEL">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.makeSlashModelWithColon') }}
					</strong>
					<br />
					{{ busingDetails.PARKING_PERMIT_MAKE_MODEL }}
				</div>
				<div class="col-sm-4" v-if="!!busingDetails.PARKING_PERMIT_CAR_COLOR">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.carColorWithColon') }}
					</strong>
					<br />
					{{ busingDetails.PARKING_PERMIT_CAR_COLOR }}
				</div>
			</div>
			<br />
			<div class="row" v-if="secondRowCarInformation()">
				<div :class="{'col-sm-3': colSize('carInfo'), 'col-sm-4': !colSize('carInfo')}"
						v-if="!!busingDetails.TRANS_STREET">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.streetWithColon') }}
					</strong>
					<br />
					{{ busingDetails.TRANS_STREET }}
				</div>
				<div :class="{'col-sm-3': colSize('carInfo'), 'col-sm-4': !colSize('carInfo')}"
						v-if="!!busingDetails.TRANS_BLOCK">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.blockWithColon') }}
					</strong>
					<br />
					{{ busingDetails.TRANS_BLOCK }}
				</div>
				<div :class="{'col-sm-3': colSize('carInfo'), 'col-sm-4': !colSize('carInfo')}"
						v-if="!!busingDetails.TRANS_ZONE">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.zoneWithColon') }}
					</strong>
					<br />
					{{ busingDetails.TRANS_ZONE }}
				</div>
				<div :class="{'col-sm-3': colSize('carInfo'), 'col-sm-4': !colSize('carInfo')}"
						v-if="!!busingDetails.TRANS_NOTES">
					<strong>
						{{ $t('MAIN_CONTENT.BusingDetails.carNotesWithColon') }}
					</strong>
					<br />
					<p v-html="busingDetails.TRANS_NOTES"/>
				</div>
			</div>
		</template>
		<!-- End of Car Information -->
	</div>
</template>

<script>
	export default {
		name: 'BusingDetails',
		props: {
			busingDetails: {
				type:			Object,
				required:	true
			},
			busPeriods: {
				type:			Array,
				default: function() {
					return []
				}
			}
		},
		methods: {
			colSize(area) {
				let sizeThree = false;

				if(area === 'carInfo') {
					if(!this.busingDetails.TRANS_ZONE && !this.busingDetails.TRANS_STREET && !this.busingDetails.TRANS_BLOCK &&
						 !this.busingDetails.TRANS_NOTES) {
						sizeThree = true;
					}
				}

				return sizeThree;
			},
			hasCarInformation() {
				return !!this.busingDetails.PARKING_PERMIT_LICENSE_PLATE_ID ||
								!!this.busingDetails.PARKING_PERMIT_MAKE_MODEL ||
								!!this.busingDetails.PARKING_PERMIT_CAR_COLOR ||
								!!this.busingDetails.TRANS_STREET ||
								!!this.busingDetails.TRANS_BLOCK ||
								!!this.busingDetails.TRANS_ZONE ||
								!!this.busingDetails.TRANS_NOTES;
			},
			firstRowCarInformation() {
				return !!this.busingDetails.PARKING_PERMIT_LICENSE_PLATE_ID ||
								!!this.busingDetails.PARKING_PERMIT_MAKE_MODEL ||
								!!this.busingDetails.PARKING_PERMIT_CAR_COLOR;
			},
			secondRowCarInformation() {
				return !!this.busingDetails.TRANS_STREET ||
								!!this.busingDetails.TRANS_BLOCK ||
								!!this.busingDetails.TRANS_ZONE ||
								!!this.busingDetails.TRANS_NOTES;
			}
		}
	};
</script>
